/**
 *  Copyright (c) 2022-present TVM Engineering Authors.
 *
 */

import types from "../actions/types";
// import { ROLES } from '../config';

const INITIAL_STATE = {
    companies: [],
};

export default function companiesReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case types.GET_COMPANIES:
            return { ...state, companies: action.payload };
        default:
            return state;
    }
}

// Selectors
export const getAllCompanies = (state) => {
    return state.companies.companies;
};